import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var leadUrlConfig = {
    searchLead: URLConfig.config.apiBase + microService.leadService + "Leads/Search",
    leadDetails: URLConfig.config.apiBase + microService.leadService + "Leads/Details",
    viewLeadDetails: URLConfig.config.apiBase + microService.leadService + "Leads/View",
    validateOtp: URLConfig.config.apiBase + microService.leadService + "Leads/validateotp",
    validateotpEncrypted: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/validateotpEncrypted",
    leadPastIntraction: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/PastInteractions",
    leadOtp: URLConfig.config.apiBase + microService.leadService + "Leads/otp",
    updateClientRegistration: URLConfig.config.apiBase + microService.leadService + "Leads/ClientRegUcc",
    PartnerUPC: URLConfig.config.apiBase + microService.leadService + "Leads/PartnerUPC",
    clientProfileDetails: URLConfig.config.apiBase + microService.leadService + "Client/Profile",
    saveLead: URLConfig.config.apiBase + microService.leadService + "Leads/LeadTask",
    encryptedLeadTask: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/LeadTaskEncrypted",
    updateLead: URLConfig.config.apiBase + microService.leadService + "Leads/UpdateLead",
    // leadLogs:
    //   URLConfig.config.apiBase + microService.leadService + "Leads/Activities",
    leadLogs: URLConfig.config.apiBase + microService.leadService + "Leads/Logs",
    ProfilePic: URLConfig.config.apiBase + microService.leadService + "Client/ProfilePic",
    ProfilePicAll: URLConfig.config.apiBase +
        microService.leadService +
        "Client/ProfilePicAll",
    ProfilePicId: URLConfig.config.apiBase + microService.leadService + "Client/ProfilePicId",
    ProfilePicList: URLConfig.config.apiBase +
        microService.leadService +
        "Client/ProfilePicList",
    clickToCall: URLConfig.config.apiBase + microService.leadService + "Leads/ClickToCall",
    sendProductPitchEmail: URLConfig.config.apiBase + microService.leadService + "Leads/ProductPitch",
    leadsPitch: URLConfig.config.apiBase + microService.leadService + "Leads/Pitch",
    leadsComments: URLConfig.config.apiBase + microService.leadService + "Leads/Comments",
    leadRedirection: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/RedirectionUrl",
    checkDedupe: URLConfig.config.apiBase + microService.leadService + "Leads/CheckDedupe",
    checkPanDedupe: URLConfig.config.apiBase + microService.leadService + "Leads/CheckPanDedup",
    productFeedback: URLConfig.config.apiBase +
        microService.leadService +
        "masters/ProductFeedback",
    LeadPriority: URLConfig.config.apiBase + microService.leadService + "Master/LeadPriority",
    ProductName: URLConfig.config.apiBase + microService.leadService + "Master/ProductName",
    sendVerificationLink: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/SendVerificationLink",
    verificationLink: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/VerificationLink",
    categoryMasterLink: URLConfig.config.apiBase +
        microService.leadService +
        "Master/CategoryMaster",
    panVerification: URLConfig.config.apiBase + microService.masterSevice + "Pan/AadharSeeding",
    panVerificationNew: URLConfig.config.apiBase +
        microService.masterSevice +
        "Pan/PanVerification",
    checkPartnerDedupe: URLConfig.config.apiBase + microService.leadService + "Leads/PartnerDedupe",
    validationPipelineAmount: URLConfig.config.apiBase +
        microService.leadService +
        "masters/GetValidationPiplineAmt",
    clientProfileUpdate: URLConfig.config.apiBase +
        microService.leadService +
        "Client/ProfileUpdate",
    searchProductByIssuerName: URLConfig.config.apiBase + microService.leadService + "Master/IssuerName",
    getCategorySubCategoryByIssuerName: URLConfig.config.apiBase +
        microService.leadService +
        "Master/catsubcatbyissuer",
    partnerCodesNew: URLConfig.config.apiBase + microService.leadService + "masters/PartnerCode",
    followUpAging: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/Upcoming/FollowupAging",
    criticalPriorityAging: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/CriticalPriortyAging",
    remappingClientTaskCount: URLConfig.config.apiBase +
        microService.leadService +
        "notif/RemappingClientTaskCount",
    pipelineAgingLeadCount: URLConfig.config.apiBase +
        microService.leadService +
        "notif/getchangePipelineCounts",
    getCriticalfollowUpCount: URLConfig.config.apiBase +
        microService.leadService +
        "notif/getCriticalfollowUpCount",
    SBCodeMaster: URLConfig.config.apiBase + microService.leadService + "masters/SB",
    PanMandatoryCat: URLConfig.config.apiBase +
        microService.leadService +
        "Master/PanMandatoryCat",
    DIY_SearchAOPLeadDetails: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/DIY_SearchAOPLeadDetails",
    UccStatus: URLConfig.config.apiBase + microService.leadService + "Leads/UccStatus",
    UccDedup: URLConfig.config.apiBase + microService.leadService + "Leads/UccDedup",
    EmailUpdate: URLConfig.config.apiBase + microService.leadService + "Leads/Email",
    PanUpdate: URLConfig.config.apiBase + microService.leadService + "Leads/pan",
    getCountryCodesList: URLConfig.config.apiBase + microService.leadService + "NRI/CountryCode",
    getAccountOpeningUrls: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/AOPLinkoneplatform",
};
export default leadUrlConfig;
